import { normalisePrice, handleUnit } from 'lib/utils';
import type { Price } from 'lib/types/pricing';

interface ProductPriceProps {
  isOnSale: boolean;
  isOnClearance: boolean;
  price: Price;
  priceBeforeCurrentSale: number | string;
  priceBeforeCurrentSaleIncVAT: number | string;
  vatExclusive: boolean;
}

const ProductPrice = ({
  isOnClearance,
  isOnSale,
  price,
  priceBeforeCurrentSale,
  priceBeforeCurrentSaleIncVAT,
  vatExclusive,
}: ProductPriceProps) => {
  const {
    price: productPrice,
    price_inclusive: priceInclusive,
    quantity,
    unit,
  } = price;

  const rawPrice = vatExclusive ? productPrice : priceInclusive;
  const vatLabel = vatExclusive ? 'inc VAT' : 'ex VAT';
  const vatPrice = vatExclusive ? price.price_inclusive : price.price;
  const normalisedPrice = normalisePrice(rawPrice);
  const normalisedPriceAttr = normalisePrice(rawPrice, false);
  const normalisedPriceBeforeSale = normalisePrice(
    vatExclusive ? priceBeforeCurrentSale : priceBeforeCurrentSaleIncVAT,
  );
  const normalisedVatPrice = normalisePrice(vatPrice);

  const priceClasses = `price${
    isOnSale || isOnClearance ? ' tc-cef-red' : ' tc-black'
  }`;

  return (
    <>
      <div className="price-inc-moq" data-price={normalisedPriceAttr}>
        <span className={priceClasses}>{normalisedPrice}</span>
        <span className="moq">
          For {quantity}
          {handleUnit(unit)}
        </span>
        {isOnSale && (
          <span className="price-inc-moq__price-before-current-sale">
            Was <span className="td-lt">{normalisedPriceBeforeSale}</span>
          </span>
        )}
      </div>
      <div className="vat-switch">
        <span>
          {normalisedVatPrice} {vatLabel}
        </span>
      </div>
    </>
  );
};

export default ProductPrice;
